import(/* webpackMode: "eager" */ "/home/runner/work/frontend/frontend/apps/web/app/global-error.tsx");
